<template>

    <div>

        <!-- show loading indicator -->
		<loading-indicator :loading="isLoading"></loading-indicator>

        <!-- <lang labelKey="CALENDAR-MARKETING_CHANNEL-CAMPAIGNS"></lang> -->

	    <template v-if="!isLoading">


			<v-client-table ref="tblTodos" name="tblTodos" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tbl-todos noFirstColumn">

				<!-- before table: FILTER OPTIONS -->
                <template slot="beforeTable">

					<div class="is-pulled-left">

						<div class="columns is-marginless filters">

                            <!-- STATUS -->
                            <div class="column">
                                <form-input inputType="select" :selectOptions="optionsStatus" label="TODO-STATUS" v-model="filterStatus" :selectAllowEmpty="false" :showLabelInOptions="false"></form-input>
                            </div>

                            <!-- DATUM -->
                            <div class="column">
                                <div class="control">
        							<div class="control-label"><label-name labelKey="CALENDAR-FILTER-EVENT_DATE"></label-name></div>
        							<div class="control"><datepicker placeholder="Datum" :options="datePickerOptions" v-model="filterDate"></datepicker></div>
        						</div>
                            </div>

                            <!-- CHANNELS -->
                            <div class="column">
                                <form-input inputType="select" selectFieldName="displayName" :selectOptions="optionsChannels" label="CALENDAR-FILTER-CHANNEL" v-model="filterChannel" :selectAllowEmpty="true" :showLabelInOptions="false"></form-input>
                            </div>

                            <!-- RESPONSIBILITY -->
                            <div class="column" v-if="this.activeUser.userRole.name != 'Apotheke'">
                                <form-input inputType="select" :selectOptions="calendarEntryTaskResponsibilityTypes" label="TODO-RESPONSIBILITY" v-model="filterResponsibility" :selectAllowEmpty="true" :showLabelInOptions="true"></form-input>
                            </div>

                    	</div>
					</div>

                </template>

				<!-- marketingChannel -->
				<template slot="marketingChannel" slot-scope="props">
                    {{ getChannelCustomizationName(props.row.marketingChannel) }}
				</template>

				<!-- title  -->
				<template slot="todo" slot-scope="props">
                    {{ props.row.title }}
				</template>

				<!-- deadline -->
				<template slot="deadline" slot-scope="props">
                    {{ formatDate2(props.row.deadline, false) }}
				</template>

                <!-- responsibility -->
				<template slot="responsibility" slot-scope="props">
                    <template v-if="props.row.responsibilityType != null">
                    {{ $t('CALENDAR-TODO-RESPONSIBILITY-'+props.row.responsibilityType.name) }}
                    </template>
				</template>

				<!-- check -->
				<template slot="isCompleted" slot-scope="props">

                    <template v-if="activeUser.userRole.name == 'Apotheke' || activeUser.id == props.row.assignee">

                        <div class="checkboxWrapper">
                            <p-check class="p-icon p-pulse p-round p-bigger" color="info" :disabled="props.row.isCompleted" :checked="props.row.isCompleted" @change="setChecked(props)" :key="props.row">
                                <i slot="extra" class="icon fa fa-check"></i>
                            </p-check>
                        </div>

                    </template>

                    <template v-else>

                        <div class="checkboxWrapper">
                            <p-check class="p-icon p-pulse p-round p-bigger" color="info" :disabled="true" :checked="props.row.isCompleted" :key="props.row">
                                <i slot="extra" class="icon fa fa-check"></i>
                            </p-check>
                        </div>

                    </template>



				</template>

			</v-client-table>

		</template>

    </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

// https://lokesh-coder.github.io/pretty-checkbox/
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

import { de } from 'flatpickr/dist/l10n/de';
de.firstDayOfWeek = 1;  // Monday
de.rangeSeparator = " bis ";

export default {

    name: 'calendarTabTodos',

    props: {

        pharmacy: {
			type: Object,
			default: null
		},

        /*
        apoId: {
            type: Number,
            default: null
        },
        */

    },

    data() {

        var self = this;

        return {

            site: null,

            isLoading: false,

            filterStatus: null,
            filterChannel: null,

            filterDate: null,
            _filterDate1: null,
            _filterDate2: null,

            filterResponsibility: null,

            datePickerOptions: {
                enableTime: false,
                altInput: true,
                altFormat: 'd.m.Y',
                locale: de,
				clickOpens: true,
                weekNumbers: false,
                mode: 'range'
            },

            optionsChannels: null,
            optionsResponsibility: null,

            table: {

                tblData: [],
                tblColumns: ['marketingChannel', 'title', 'deadline', 'responsibility', 'isCompleted'],
                tblOptions: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'deadline'
                    },

                    columnsClasses: { deadline: 'deadline', responsibility: 'responsibility', isCompleted: 'isCompleted' },


                    // custom table headings - make them clickable for language Setting
                    headings: {

                        marketingChannel(h) {
                            return <lang labelKey="CALENDAR-TODOS-TBL_HEADLINE-TYPE"></lang>
                        },
                        title(h) {
                            return <lang labelKey="CALENDAR-TODOS-TBL_HEADLINE-TITLE"></lang>
                        },
                        deadline(h) {
                            return <lang labelKey="CALENDAR-TODOS-TBL_HEADLINE-DEADLINE"></lang>
                        },
                        responsibility(h) {
                            return <lang labelKey="CALENDAR-TODOS-TBL_HEADLINE-RESPONSIBILITY"></lang>
                        },
                        isCompleted(h) {
                            return <lang labelKey="CALENDAR-TODOS-TBL_HEADLINE-isCompleted"></lang>
                        },
                    },

                    sortable: ['marketingChannel', 'deadline'],
                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // initial filtering
                    initFilters: {

                        filter: {
                            isCompleted: false,
                            responsibility: self.filterResponsibility,
                            dates: [ self.getInitFilterDate(true), self.getInitFilterDate(false) ]
                        }

                    },

                    // custom filter functions
					customFilters: [
						{
						name: 'filter',

							callback(row, payload) {

                                var isQualified = true;

                                if(row.isCompleted != payload.isCompleted) {
                                    return false;
                                }

                                // filter dates
                                if(isQualified && payload.dates != null) {
                                    let deadline = new Date(row.deadline);
                                    isQualified = deadline >= payload.dates[0] && deadline <= payload.dates[1];
                                }

                                // filter channel
                                if(isQualified && payload.channel != null) {
                                    isQualified = row.marketingChannel == payload.channel;
                                }

                                // filter responsibility
                                if(isQualified && payload.responsibility != null) {
                                    isQualified = row.responsibilityType.name == payload.responsibility.name;
                                }

                                return isQualified;

                            }

                        }

                    ]

                }

            }
        }


    },

    beforeCreate() {

    },


    created() {

        this.site = this.pharmacy;

        this.filterResponsibility = this.activeUser.userRole.name == 'Apotheke' ? { name: 'SITE' } : null ;
        this.filterStatus = { id: 1, name: 'offen', value: false };
        this.fetchData();

    },

    mounted() {

        let d1 = new Date();
        let d2 = new Date();

        d1.setMonth(d1.getMonth() - 2);
        d2.setMonth(d2.getMonth() + 2);

        this.filterDate = d1.toISOString().substring(0, 10) + ' bis ' + d2.toISOString().substring(0, 10);
        let dates = this.filterDate.split(' bis ');
        this._filterDate1 = dates[0];
        this._filterDate2 = dates[1];

    },

    watch: {

        filterStatus(val) {

            Event.$emit('vue-tables.tblTodos.filter::filter', {
                isCompleted: this.filterStatus != null ? this.filterStatus.value : null,
                channel: this.filterChannel != null ? this.filterChannel.name : null,
                responsibility: this.filterResponsibility != null ? this.filterResponsibility : null,
				dates: this.filterDate != null ? [ new Date(this._filterDate1), new Date(this._filterDate2) ] : null,
			});

        },

        filterDate(dateRange) {

            if(dateRange == "") {

                Event.$emit('vue-tables.tblTodos.filter::filter', {
                    isCompleted: this.filterStatus != null ? this.filterStatus.value : null,
                    channel: this.filterChannel != null ? this.filterChannel.name : null,
                    responsibility: this.filterResponsibility != null ? this.filterResponsibility : null,
    				dates: null,
                });

            } else {

                if(dateRange.indexOf(' bis ') > -1) {

                    // close the datePicker after selecting start and enddate
                    document.querySelectorAll('.flatpickr-input').forEach(function(i) { i._flatpickr.close(); })

                    // split the string to start- and enddate and assign both to variables
                    let dates = dateRange.split(' bis ');
                    this._filterDate1 = dates[0];
                    this._filterDate2 = dates[1];

                    Event.$emit('vue-tables.tblTodos.filter::filter', {
                        isCompleted: this.filterStatus != null ? this.filterStatus.value : null,
                        channel: this.filterChannel != null ? this.filterChannel.name : null,
                        responsibility: this.filterResponsibility != null ? this.filterResponsibility : null,
        				dates: this.filterDate != null ? [ new Date(this._filterDate1), new Date(this._filterDate2) ] : null,
        			});

                }

            }


        },

        filterChannel(ch) {

            Event.$emit('vue-tables.tblTodos.filter::filter', {
                isCompleted: this.filterStatus != null ? this.filterStatus.value : null,
                channel: this.filterChannel != null ? this.filterChannel.name : null,
                responsibility: this.filterResponsibility != null ? this.filterResponsibility : null,
				dates: this.filterDate != null ? [ new Date(this._filterDate1), new Date(this._filterDate2) ] : null,
			});

        },

        filterResponsibility(val) {

            Event.$emit('vue-tables.tblTodos.filter::filter', {
				isCompleted: this.filterStatus != null ? this.filterStatus.value : null,
                channel: this.filterChannel != null ? this.filterChannel.name : null,
                responsibility: this.filterResponsibility != null ? this.filterResponsibility : null,
				dates: this.filterDate != null ? [ new Date(this._filterDate1), new Date(this._filterDate2) ] : null,
			});

        },

    },

    computed: {


		apoId() {
			return this.site != null ? this.site.id : null;
		},

        optionsStatus() {

            var res = [
                {
                    id: 1,
                    name: 'offen',
                    value: false
                },
                {
                    id: 2,
                    name: 'erledigt',
                    value: true
                },
            ];

            return res;

        },

        calendarEntryTaskResponsibilityTypes() {
			return this.$store.getters.getTermsByTaxonomy('CALENDAR_ENTRY_TASK_RESPONSIBILITY_TYPES');
		},

    },


    methods: {

        getChannelCustomizationName(channel) {

			// wenn site.marketingChannelCustomizations[TERM_NAME].name, diesen Namen anstelle des Labels verwenden
			if(this.site != null
                && this.site.marketingChannelCustomizations != null
                && typeof this.site.marketingChannelCustomizations[channel] != 'undefined'
                && typeof this.site.marketingChannelCustomizations[channel].name != 'undefined') {
				return this.site.marketingChannelCustomizations[channel].name;
			} else {
				return this.$t('CALENDAR-MARKETING_CHANNEL-'+channel);
			}

		},

        getInitFilterDate(startDate=false) {

            let d1 = new Date();
            let d2 = new Date();

            d1.setMonth(d1.getMonth() - 2);
            d2.setMonth(d2.getMonth() + 2);

            this.filterDate = d1.toISOString().substring(0, 10) + ' bis ' + d2.toISOString().substring(0, 10);
            let dates = this.filterDate.split(' bis ');

            return startDate ? new Date(dates[0]) : new Date(dates[1]);
        },

        setChecked(props) {

            // var todo = this.$refs.tblTodos.data.find(row => row.id == props.row.id);
            var todo = this.table.tblData.find(row => row.id == props.row.id);

            /*
            setTimeout(function() {
                todo.isCompleted = !todo.isCompleted;
            }, 1500);
            */

            var self = this;

            this.axios.get(this.$config.api + 'calendarEntryTask/'+todo.id+'/complete')
                .then(response => {

                    todo.isCompleted = !todo.isCompleted;
                    self.$notify.open({ content: 'Todo wurde als erledigt markiert!', type: 'success' });

                });

        },


        fetchData() {

            this.isLoading = true;

            var self = this;
            let url = this.$config.api + 'calendarEntryTask';

            url += this.apoId != null
                ? '?site='+this.apoId
                : '';

            this.axios.get(url)
                .then(response => {

                    var channels = [];

                    // add channel as option to the dropdown
                    response.data.calendarEntryTask.forEach(task => {
                        if(channels.length > 0 && channels.findIndex(ch => ch.name == task.marketingChannel) == -1) {

                            let chName = "";

                            // wenn site.marketingChannelCustomizations[TERM_NAME].name, diesen Namen anstelle des Labels verwenden
                			if(this.site != null
                                && this.site.marketingChannelCustomizations != null
                                && typeof this.site.marketingChannelCustomizations[task.marketingChannel] != 'undefined'
                                && typeof this.site.marketingChannelCustomizations[task.marketingChannel].name != 'undefined') {
                				chName = this.site.marketingChannelCustomizations[task.marketingChannel].name;
                			} else {
                				chName = this.$t('SELECT_BOX-CALENDAR-FILTER-CHANNEL-'+task.marketingChannel);
                			}

                            channels.push( { name: task.marketingChannel, displayName: chName } );

                        }

                    })

                    self.optionsChannels = channels;

                    self.table.tblData = response.data.calendarEntryTask;

                    /*
                    self.table.tblData.forEach(data => {
                        console.log(data.responsibilityType);
                    })
                    */

                    self.isLoading = false;

                });


        }
    }

}

</script>


<style lang="scss">
    @import '~pretty-checkbox/src/pretty-checkbox.scss';
</style>

<style scoped>

    .tbl-todos >>> tr td {
        cursor: auto;
    }
    .tbl-todos >>> th:first-child {
        width: 140px;
    }
    .tbl-todos >>> th:last-child {
        width: 100px;
        text-align: center;
    }
    .tbl-todos >>> th.deadline {
        width: 120px;
    }
    .tbl-todos >>> th.responsibility {
        width: 150px;
    }
    .tbl-todos >>> td:last-child {
        position: relative;
    }
    .tbl-todos >>> td:last-child .checkboxWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0; right: 0;
        top: 0;
        bottom: 0;
        padding-left: 4px;
    }
    .tbl-todos >>> td:last-child .checkboxWrapper .pretty {
        margin-right: 0;
    }

    >>> .datepicker {
        width: 210px;
        display: block;
    }
</style>
